import 'datatables.net';

export default function (classSelector = '.block--searchable-table') {
  $(classSelector).each(function () {
    const $block = $(this);
    const tableSelector = $block.find('table');

    // Initialize DataTables
    tableSelector.each(function () {
      const table = $(this).DataTable({
        searching: true,
        paging: false,
        ordering: false,
        info: false,
        lengthChange: false,
        language: {
          search: '',
        },
        dom: '<"search-form">rt',
        drawCallback: function () {
          toggleShowAllButton($block, this.api());
        },
      });

      if (!$(this).parent().hasClass('searchable-table__container')) {
        $(this).wrap('<div class="searchable-table__container"></div>');
      }

      toggleShowAllButton($block, table);
    });

    // Configure search functionality
    $block.find('.search-form').html(`
      <div class="search-form__form">
        <input type="search" class="search-form__input" placeholder="Search by keyword"/>
        <button type="button" class="search-form__submit button--primary">SEARCH</button>
      </div>
    `);

    $block.find('.search-form input').on('keyup', function () {
      const table = tableSelector.DataTable();
      table.search(this.value).draw();
      toggleShowAllButton($block, table);
    });

    // Handle "Show All / Show Less" button
    $block.find('.show-all').on('click', function () {
      initShowBtn($block, $(this));
    });

    // Adjust table on window resize
    $(window).on('resize', function () {
      toggleShowAllButton($block, tableSelector.DataTable());
    });
  });

  // Manage row visibility and "Show All" button
  function toggleShowAllButton($block, table) {
    const $showAllButton = $block.find('.show-all');
    const $wrapper = $block.find('.searchable-table__wrapper');
    const $table = $wrapper.find('table');
    const rows = table.rows({ search: 'applied' }).nodes();
    const maxHeight = window.innerWidth <= 768 ? 700 : 1500;

    let totalHeight = 0;
    let visibleRows = [];

    $(rows).each(function () {
      totalHeight += $(this).outerHeight();
      if (totalHeight <= maxHeight) {
        visibleRows.push(this);
      }
    });

    if (totalHeight > maxHeight) {
      $showAllButton.show().text('Show All').data('show-all', false);
      $wrapper.addClass('has-overflow');
      $(rows).hide();
      $(visibleRows).show();
    } else {
      $showAllButton.hide();
      $wrapper.removeClass('has-overflow');
      $(rows).show();
    }
  }

  // Toggle row visibility on button click
  function initShowBtn($block, el) {
    const isShowingAll = el.data('show-all');
    const table = $block.find('table').DataTable();
    const rows = table.rows({ search: 'applied' }).nodes();
    const $wrapper = $block.find('.searchable-table__wrapper');
    const tablePosition = $block.offset().top;

    if (isShowingAll) {
      toggleShowAllButton($block, table);
      el.text('Show All').data('show-all', false);
      $wrapper.addClass('has-overflow');

      $('html, body')
        .stop()
        .animate({ scrollTop: tablePosition - 20 }, 300);
    } else {
      $(rows).show();
      el.text('Show Less').data('show-all', true);
      $wrapper.removeClass('has-overflow');
    }
  }
}
